@if (viewLoading) {
<mat-progress-spinner class="loader-pos loader-custom SF-loader" mode="indeterminate"
    [diameter]="50"></mat-progress-spinner>
}
@if (isSupCode) {
<div style="display: flex;height: 100%; justify-content: center;align-items: center;" class="row">
    <div class="col-md-8 col-md-offset-2">
        <h1 style="padding-top: 10px;text-align: center;" class="text-center">Please provide valid Details.</h1>
        <div style="height: 1px" id="pixelImg"></div>
    </div>
</div>
}

@if (isURL) {
<div style="display: flex;height: 100%; justify-content: center;align-items: center;" class="row">
    <div class="col-md-8 col-md-offset-2">
        <h1 class="text-center" aria-label="Error: Please provide valid URL.">Please provide valid URL.</h1>
        <div style="height: 1px" id="pixelImg"></div>
    </div>
</div>
}

@if (!viewLoading && !isSupCode && !isURL) {
<div class="survey-section">
    @if (isStartHeading) {
    <div class="header-window">
        <div class="light-blue-text">
            <h1 class="text-center" aria-label="Let’s Get This Survey Started!">Let’s Get This Survey Started!</h1>
        </div>
    </div>
    }
    @if (displayQuestions[currentQuesIndex]) {
    <div class="survey-window">
        <form name="demographic_form" #demographicForm="ngForm">
            <div>
                <h5 class="question-text m-t-10">
                    {{ displayQuestions[currentQuesIndex].QuestionText }}
                </h5>
                <div class="d-flex flex-direction-column">
                    <!-- Single Punch Question Start -->
                    @if (displayQuestions[currentQuesIndex].QuestionType === config.questionTypes[0]) {
                    <div>
                        <mat-radio-group name="radioOptField" #radioOptField="ngModel"
                            [(ngModel)]="payload[displayQuestions[currentQuesIndex].QuestionKey]"
                            class="d-flex flex-direction-column" required>
                            @for (option of displayQuestions[currentQuesIndex].QuestionOptions; track option) {
                            <mat-radio-button class="theme-radio m-t-20" [value]="option.OptionText">
                                {{ option.OptionText }}
                            </mat-radio-button>
                            }
                        </mat-radio-group>
                        @if (validatedQuestions[currentQuesIndex] &&
                        !payload[displayQuestions[currentQuesIndex].QuestionKey]) {
                        <div>
                            <mat-error class="err-msg">This question is required.</mat-error>
                        </div>
                        }
                    </div>
                    }
                    <!-- Single Punch Question Ends -->
                    <!-- Numeric Open Ended Questions Start -->
                    @if (displayQuestions[currentQuesIndex].QuestionType === this.config.questionTypes[3]) {
                    <div class="d-flex flex-align-baseline flex-direction-column theme-input noNumberStyle wid-230">
                        <!-- ZIPCODES -->
                        @if (displayQuestions[currentQuesIndex].QuestionKey === 'ZIPCODES') {
                        <mat-form-field appearance="outline" [floatLabel]="'auto'">
                            <input matInput inputmode="numeric" [(ngModel)]="demographic['ZIPCODES'].selected_opt"
                                name="selectedInputOptField" #selectedInputOptField="ngModel"
                                (input)="payload['ZIPCODES'] = demographic['ZIPCODES'].selected_opt; invalidZipcodeMsg = ''"
                                required>
                            @if (selectedInputOptField?.dirty || selectedInputOptField?.touched) {
                            <div class="err-msg">
                                @if (selectedInputOptField.errors?.['required']) {
                                <span>ZIPCODE is required</span>
                                }
                                @if (!zipCodeExists && validatedQuestions[currentQuesIndex]) {
                                <span>{{invalidZipcodeMsg}}</span>
                                }
                            </div>
                            }
                        </mat-form-field>
                        }
                        <!-- AGE -->
                        @if (displayQuestions[currentQuesIndex].QuestionKey === 'AGE') {
                        <mat-form-field appearance="outline" [floatLabel]="'auto'">
                            <input matInput type="number" [(ngModel)]="demographic['AGE'].selected_opt"
                                name="selectedInputOptField1" #selectedInputOptField1="ngModel" min="13" max="99"
                                pattern="^[0-9]*$" (input)="payload['AGE'] = demographic['AGE'].selected_opt" required>
                            @if ((selectedInputOptField1?.dirty || selectedInputOptField1?.touched)) {
                            <mat-error class="err-msg">
                                @if (selectedInputOptField1.errors?.['required']) {
                                <span>AGE is required</span>
                                }
                                @if (selectedInputOptField1.errors?.['min'] || selectedInputOptField1.errors?.['max'] ||
                                selectedInputOptField1.errors?.['pattern']) {
                                <span>
                                    Please enter digits between 13 to 99.</span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                        }
                    </div>
                    }
                    @if (displayQuestions[currentQuesIndex].QuestionType !== 'Single Punch'
                    && displayQuestions[currentQuesIndex].QuestionType !== 'Multipunch'
                    && displayQuestions[currentQuesIndex].QuestionType !== 'Numeric Open Ended'
                    && displayQuestions[currentQuesIndex].QuestionType !== 'Open End-Text'
                    ) {
                    <div>
                        oh no, you don't have it
                    </div>
                    }
                </div>
                <!-- Numeric Open Ended Questions End -->
                <div class="d-flex flex-align-center">
                    @if (currentQuesIndex > 0) {
                    <button class="next_btn m-t-30 m-b-30 m-r-20" type="button" (click)="previousQuestion()">Previous
                    </button>
                    }
                    @if (currentQuesIndex < totalQues - 1) { <button class="next_btn m-t-30 m-b-30" type="button" [disabled]="isNextResponse || !rdResponseReady"
                        (click)="nextQuestion()">Next
                        </button>
                        }
                        @if (currentQuesIndex === totalQues - 1) {
                        <button class="next_btn m-t-30 m-b-30" type="submit" [disabled]="isDisableSubmit || !rdResponseReady"
                            (click)="submitForm()">Submit
                        </button>
                        }
                </div>
            </div>
        </form>
    </div>
    }
</div>
}